(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'banner', {
            bindings: {
                bannerModel: '<'
            },
            templateUrl:    'app/views/partials/layout/banner.html',
            controller:     BannerController,
            controllerAs:   'vm'
        });


    /**
     * Renders the top page banner and all its components.
     *
     * @param {ng.IScope} $scope
     * @param {ContentSwitchingService} ContentSwitchingService
     * @param {SubpagesService} SubpagesService
     * @param {Utils} Utils
     * @param {Object} CONFIG
     */
    function BannerController(
        $scope,
        ContentSwitchingService,
        SubpagesService,
        Utils,
        CONFIG
    ){
        // Helping members.

        /** @type {angular.IController} */
        var vm = this;


        /** @constructor */
        vm.$onInit = function() {
            setWatchers();
        };



        /** Private functions. */

        function setWatchers() {
            $scope.$watch( function() { return $scope.vm.bannerModel; },
            /** @param {Object} newBannerModel */
            function( newBannerModel ) {
                if ( newBannerModel ) {
                    vm.banner = {};
                    updateModelByContentType();

                    vm.banner.imagePath = newBannerModel.coverImageUrl ? newBannerModel.coverImageUrl : CONFIG.UI.PATHS.IMAGES.BANNER_DEFAULT;
                }
    		});
        }


        function updateModelByContentType(){
            if ( !vm.bannerModel || !Utils.getSharedContent().applyNowButtons ) return;

            var isInternationalContent = ContentSwitchingService.isInternational(),
            CTAButton = Utils.getSharedContent().applyNowButtons.asset_contents;

            if( vm.bannerModel && isInternationalContent ){
                vm.banner.CTAButton = CTAButton.international;
            } else {
                vm.banner.CTAButton = CTAButton;
            }
        }
    }


    BannerController.$inject = [ '$scope', 'ContentSwitchingService', 'SubpagesService', 'Utils', 'CONFIG' ];
})();
